import React from 'react';
import Success_Lottie from '../../../../animations/success_lottie/Success_Lottie';
import Common_recharge_page_banner from '../../../../common_components/common_banner/common_recharge_page_banner/Common_recharge_page_banner';
import Proceed_btn from '../../../../common_components/common_btn/proceed_btn/Proceed_btn';
import Mobile_prepaid_plan_card from '../../../../common_components/common_cards/mobile_prepaid_plan_card/Mobile_prepaid_plan_card';
import Mobile_recharge_plan_card from '../../../../common_components/common_cards/mobile_recharge_plan_card/Mobile_recharge_plan_card';
import Successfull_Modal from '../../../../common_components/common_modal/successfull_modal/Successfull_Modal';
import Contribution from '../../../../home/contribution/Contribution';
import "./Airtel_Prepaid.css";

function Airtel_Prepaid() {
    const [modalShow, setModalShow] = React.useState(false);
    const breadcrumbData = [
        { label: "Services", path: "/services" },
        { label: "Mobile Recharge", path: "/mobile-recharge" },
        { label: "Airtel Prepaid" },

    ];
    return (
        <>
            <section className='Airtel_Prepaid'>
                <Common_recharge_page_banner
                    title="MOBILE RECHARGES"
                    breadcrumbItems={breadcrumbData}
                />

                {/* Left Side - Form */}
                <div className="Mobile_Recharge">
                    <div className="container">
                        <div className="recharge_form_section form_box_section">
                            <div className="row justify-content-center">
                                <div className="col-md-8 col-12">
                                    <Mobile_prepaid_plan_card />

                                    <div className="select_plan_hodler">
                                        <div className="heading_text">
                                            <h6>Selected Plan:</h6>
                                        </div>

                                        <Mobile_recharge_plan_card />
                                    </div>

                                    <div className="btn_holder ">
                                        <Proceed_btn
                                            btnText="Proceed To Pay"
                                            className="save_changes_btn"
                                            onClick={() => setModalShow(true)}
                                        />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Contribution />

            </section>
            <Successfull_Modal
                show={modalShow}
                message="Mobile Recharge Successful!"
                subMessage="Your Recharge is Complete, Payment received & your plan is now active."
                onHide={() => setModalShow(false)}
                lottie={<Success_Lottie />}
            />
        </>
    )
}

export default Airtel_Prepaid